import { gql, type TypedDocumentNode } from '@apollo/client';

export type BuildInfo = {
  sha: string | null;
  ref: string | null;
  title: string | null;
  author: string | null;
  repoUrl: string | null;
};

export const BUILD_INFO_QUERY: TypedDocumentNode<{ buildInfo: BuildInfo }> =
  gql`
  query buildInfo {
    buildInfo @rest(type: "BuildInfo", method: "GET", path: "/build-info") {
      sha
      ref
      title
      author
      repoUrl
    }
  }
`;
